import React from 'react'
import { ReactComponent as Logo } from './../../images/logo_vertical_colored.svg'
import { useForm } from 'react-hook-form'
import { Button } from '@demandlocal/components'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useLocation } from 'react-router'
import { setAuthenticated, setUser } from '../../store/reducers/userReducer'
import { GA4 } from '../../lib/utils/ga4'
import mtm from '../../lib/utils/mtm'
import { useDispatch } from 'react-redux'
import { useDealershipStore } from '../../store/zustand/dealershipStore'
import { useAuthAcceptTerms } from '../../api/auth/useAuthAcceptTerms'
import Terms from '../Landing/Terms'
import { useGetUser } from '../../api/auth/useGetUser'

export default function TermsAndConditions(): JSX.Element {
  const location = useLocation()
  const [showTerms, setShowTerms] = React.useState(false)
  const next = location?.state?.next
  const dispatch = useDispatch()
  const { data: user, isLoading: isLoadingUser } = useGetUser()
  const data = location?.state?.user ?? user
  const setDealership = useDealershipStore((state) => state.setDealership)
  const { mutateAsync: authAcceptTermsAsync } = useAuthAcceptTerms()
  const {
    control,
    handleSubmit,
    setError,
    setValue,
    formState: { isSubmitting },
  } = useForm({
    mode: 'onSubmit',
  })

  const navigate = useNavigate()

  const onSubmit = async (): Promise<void> => {
    console.log(data)
    if (data) {
      await authAcceptTermsAsync({
        user_id: data.id,
      })
      await dispatch(setUser(data))
      await dispatch(setAuthenticated(true))
      GA4.configureUser(data)
      GA4.sendEvent({
        event_name: 'login_success',
        event_params: {},
      })
      mtm.sendEvent('Login', 'Success', data.email)

      if (data.organizations?.length > 0) {
        const organizations = data?.organizations ?? []
        const dealership = organizations[0]?.dealerships?.[0]
        setDealership(dealership)
      }
      navigate('/dashboard')
      if (next) {
        navigate(next)
        return
      }
    } else {
      navigate('../login')
    }
  }
  const onCancel = (e): void => {
    e.preventDefault()
    navigate('../login')
  }
  return (
    <>
      <motion.div
        layout={'size'}
        className={'flex flex-1 items-center justify-center h-screen'}>
        <motion.div
          layout={'preserve-aspect'}
          className={'w-full max-w-xl mx-auto my-auto'}>
          <motion.div
            layout={'position'}
            layoutId={'auth-logo'}
            className={'flex justify-center p-10'}>
            <Logo className={'h-32'} />
          </motion.div>
          <motion.div
            layout={'preserve-aspect'}
            layoutId={'auth-container'}
            className={'flex flex-col w-full p-10 rounded-lg bg-cultured-gray gap-8'}>
            <div className={'font-Spartan font-bold text-xl'}>Terms and Conditions</div>
            <form onSubmit={handleSubmit(onSubmit)} className={'flex flex-col gap-6'}>
              <p className={'text-sm text-start leading-6'}>
                By logging in, you agree to follow our{'  '}
                <strong
                  onClick={(e) => {
                    setShowTerms(true)
                  }}
                  className={'font-bold text-primary-persian-blue cursor-pointer'}>
                  Terms of Services
                </strong>
                , indicating that you have read and understood them beforehand.
              </p>
              <div className={'flex justify-between'}>
                <Button
                  animate={false}
                  disabled={isSubmitting}
                  variant={'tertiary'}
                  type={'button'}
                  onClick={onCancel}>
                  Take me back
                </Button>
                <Button
                  animate={false}
                  disabled={isSubmitting || isLoadingUser}
                  type={'submit'}>
                  I Accept
                </Button>
              </div>
            </form>
          </motion.div>
        </motion.div>
      </motion.div>
      {showTerms && (
        <motion.div
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: 1,
          }}
          exit={{
            opacity: 0,
          }}
          transition={{
            type: 'spring',
            stiffness: 170,
            damping: 26,
            mass: 1,
          }}
          className={'absolute w-full h-screen z-10 top-0 left-0'}>
          <Terms
            submitButtonLabel={'Close'}
            onClose={() => {
              setShowTerms(false)
            }}
          />
        </motion.div>
      )}
    </>
  )
}
